module.exports = __webpack_public_path__ + "static/media/m2.a51b1bb5.webp";